import React from 'react'
import Dropdown from 'react-toolbox/lib/dropdown'
import { Flex, Box } from 'reflexbox'
import CSSModules from 'react-css-modules'

import theme from './FulcrumDropdown.scss'

const FulcrumDropdown = (props) => {
  let {
    defaultValue: hint,
    list: source,
    styles,
    ...rest
  } = props
  if (props.source) source = props.source
  if (props.hint) hint = props.hint

  return (
    <Dropdown 
      {...rest}
      hint={hint}
      source={source}
      theme={theme}
    />
  )
}

export default CSSModules(FulcrumDropdown, theme)
